const ITEMS = [
  "Sweet Moments, Beautifully Baked",
  "Handcrafted Wedding Tiers",
  "Organic Ingredients",
  "Bespoke Celebrations",
  "Sugar Flowers Piped by Hand",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif italic text-2xl md:text-3xl text-[#8B5D6C] whitespace-nowrap px-8">{item}</span>
        <svg viewBox="0 0 24 24" className="w-4 h-4 text-[#C5A059]" fill="currentColor" aria-hidden="true">
          <path d="M12 2c1 4 3 6 7 7-4 1-6 3-7 7-1-4-3-6-7-7 4-1 6-3 7-7z" />
        </svg>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="relative py-6 border-y border-[#C5A059]/30 bg-[#F3EEE6]/60 overflow-hidden" data-testid="editorial-marquee">
    <div className="flex animate-marquee w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
